var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCesta = function SvgCesta(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69.164,
    height: 53.245,
    viewBox: "0 0 59.164 53.245",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8115",
    "data-name": "Grupo 8115",
    transform: "translate(-56.418 -1572.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7020",
    "data-name": "Grupo 7020",
    transform: "translate(58.966 1595.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3876",
    "data-name": "Caminho 3876",
    d: "M636.83,242.45l3.216,18.5A3,3,0,0,0,643,263.435h31.719a3,3,0,0,0,2.956-2.5L680.8,242.45Zm32.827,4.676a1.042,1.042,0,0,1,.969-1.1h1.936a1.043,1.043,0,0,1,.969,1.1v11.032a1.043,1.043,0,0,1-.969,1.1h-1.936a1.042,1.042,0,0,1-.969-1.1Zm-8.52,0a1.043,1.043,0,0,1,.969-1.1h1.936a1.042,1.042,0,0,1,.968,1.1v11.032a1.042,1.042,0,0,1-.968,1.1h-1.936a1.042,1.042,0,0,1-.969-1.1Zm-8.519,0a1.042,1.042,0,0,1,.967-1.1h1.936a1.042,1.042,0,0,1,.968,1.1v11.032a1.042,1.042,0,0,1-.968,1.1h-1.936a1.042,1.042,0,0,1-.967-1.1Zm-8.52,0a1.042,1.042,0,0,1,.968-1.1H647a1.042,1.042,0,0,1,.968,1.1v11.032a1.042,1.042,0,0,1-.968,1.1h-1.936a1.042,1.042,0,0,1-.968-1.1Z",
    transform: "translate(-636.83 -242.45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7021",
    "data-name": "Grupo 7021",
    transform: "translate(72.021 1572.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3877",
    "data-name": "Caminho 3877",
    d: "M772.986,13.5l6.98,14.384a1.982,1.982,0,0,0,.751.83,2,2,0,0,0,2.845-2.574l-6.98-14.384a2,2,0,0,0-3.6,1.745Z",
    transform: "translate(-772.785 -10.63)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3878",
    "data-name": "Caminho 3878",
    d: "M917.693,170.442h-19.42a3.922,3.922,0,0,1-1.209,4h20.628a1,1,0,0,0,1-1v-2A1,1,0,0,0,917.693,170.442Z",
    transform: "translate(-813.11 1417.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3879",
    "data-name": "Caminho 3879",
    d: "M630.967,173.191l-1.334-2.749H611.294a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h20.631A3.912,3.912,0,0,1,630.967,173.191Z",
    transform: "translate(-553.877 1417.873)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCesta, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cesta.5d6012b0.svg";
export { ForwardRef as ReactComponent };